import {
  ApiBnplAttributes,
  ApiBnplCreditOffer,
  ApiCreditOfferTypes,
  ApiCtaCreditOffer,
  ApiStcAttributes,
  ApiStcCreditOffer,
  ApiTake3Attributes,
  ApiTake3CreditOffer,
  BnplAttributes,
  StcAttributes,
  Take3Attributes,
} from 'types/CreditOfferTypes';

import { getPriceWithSymbol } from 'utilities/price/price-utilities';

export const adaptTake3Attributes = (attributes: ApiTake3Attributes): Take3Attributes => {
  const [firstPayment, secondPayment, thirdPayment] = attributes.terms;

  return {
    firstPayment: getPriceWithSymbol(firstPayment.value),
    secondPayment: getPriceWithSymbol(secondPayment.value),
    thirdPayment: getPriceWithSymbol(thirdPayment.value),
  };
};

export const adaptBnplAttributes = (attributes: ApiBnplAttributes): BnplAttributes[] => {
  const adaptedTerms = attributes.terms.map(({ term, minimumOrderValue }) => ({
    months: `${term}`,
    minimumOrderValue: getPriceWithSymbol(minimumOrderValue),
  }));

  return adaptedTerms;
};

export const adaptStcAttributes = (attributes: ApiStcAttributes): StcAttributes => {
  const { amount, percent } = attributes.minPay;

  return {
    amount: getPriceWithSymbol(amount),
    percent: `${percent}%`,
  };
};

export const adaptCreditOfferAttributes = (
  creditOffer: ApiStcCreditOffer | ApiTake3CreditOffer | ApiBnplCreditOffer | ApiCtaCreditOffer,
) => {
  const { type, attributes } = creditOffer;

  switch (type) {
    case ApiCreditOfferTypes.TAKE3:
      return adaptTake3Attributes(attributes);
    case ApiCreditOfferTypes.BNPL:
      return adaptBnplAttributes(attributes);
    case ApiCreditOfferTypes.STC:
      return adaptStcAttributes(attributes);
    default:
      return attributes;
  }
};
